import config from '@base/appSettings.json';

const POPUP_SHOWN_KEY = 'newsletter_popup_shown';

export const shouldShowNewsletterPopup = async (email?: string, isButton = false): Promise<boolean> => {
    console.log('Checking newsletter visibility for email:', email, 'isButton:', isButton);

    // If no email provided, don't show anything
    if (!email) {
        console.log('No email provided, not showing');
        return false;
    }

    try {
        // Check if user is already subscribed
        console.log('Checking subscription status...');
        const response = await fetch(`${config.apiUrl}/Account/check-newsletter-submission/${email}`);
        if (!response.ok) {
            console.log('Failed to check subscription status, showing');
            return true;
        }
        const isSubscribed = await response.json();
        console.log('Subscription check result:', isSubscribed);
        if (isSubscribed['isSubscribed']) {
            console.log('User is already subscribed, not showing');
            return false;
        }

        // For the button, we don't check the time
        if (isButton) {
            console.log('Button check - showing');
            return true;
        }

        // For the popup, check the 7-day cooldown
        const popupShown = localStorage.getItem(POPUP_SHOWN_KEY);
        console.log('Last popup shown:', popupShown);

        // If never shown before, return true
        if (!popupShown) {
            console.log('Popup never shown before, showing now');
            return true;
        }

        // Otherwise, parse the stored date and check if it's been more than 1 week
        const lastShownDate = new Date(parseInt(popupShown as string, 10));
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        const shouldShow = lastShownDate < oneWeekAgo;
        console.log('Last shown:', lastShownDate);
        console.log('One week ago:', oneWeekAgo);
        console.log('Should show popup:', shouldShow);
        return shouldShow;
    } catch (error) {
        console.error('Error checking newsletter subscription:', error);
        console.log('Error occurred, showing');
        return true;
    }
};

export const markNewsletterPopupAsShown = (): void => {
    console.log('Marking popup as shown');
    localStorage.setItem(POPUP_SHOWN_KEY, Date.now().toString());
};

// Helper function to manually clear the popup state (useful for testing)
export const resetNewsletterPopupState = (): void => {
    console.log('Resetting popup state');
    localStorage.removeItem(POPUP_SHOWN_KEY);
};
